import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_ANALYSIS_REGISTRY_KEY, META_TYPE, META_VER } from './analysisCommandRegisteryType';

const DAY_MS = 86400000;
const WINDOW_DAYS = 60;

const DEFAULT_PROFILE = 'Neutral';

/**
 * Registers the /analysis command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /analysis <symbol> [profile] — opens the AnalysisWidget card for the last 60 days.
 * profile defaults to Neutral when omitted.
 */
export function registerAnalysisCommand() {
    commandEngine.register('/analysis', {
        hint: 'Open analysis widget for a symbol',
        params: [
            { name: 'symbol', hint: 'e.g. UNI' },
            {
                name: 'profile',
                options: [
                    { label: 'Defensive', value: 'Defensive' },
                    { label: 'Neutral', value: 'Neutral' },
                    { label: 'Offensive', value: 'Offensive' },
                ],
            },
        ],
        handler: (params) => {
            const symbol = (params[0] ?? '').toUpperCase();
            if (!symbol) return;

            const profile = params[1] || DEFAULT_PROFILE;

            const end = Date.now();
            const start = end - WINDOW_DAYS * DAY_MS;

            cardPainterManager.openCard(
                CMD_ANALYSIS_REGISTRY_KEY,
                { type: META_TYPE, ver: META_VER, target: `${symbol}_${profile}` },
                { symbol, profile, start, end }
            );
        },
    });
}
